<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2021-01-23 11:16 -->
<template>
  <div>
    <span v-show="disabled">{{ value }}</span>
    <div class="d-flex" v-if="!disabled">
      <button
        class="app-button"
        :disabled="value <= 1"
        @click="$emit('input', value - 1)"
      >
        -
      </button>
      <input
        :value="value"
        type="text"
        class="input-number"
        @input="$emit('input', $event.target.value)"
      />
      <button class="app-button" @click="$emit('input', value + 1)">+</button>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    disabled: {
      default: false
    },
    value: {
      //
    }
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    //
  }
};
</script>

<style scoped>
.input-number {
  width: 3rem;
  text-align: center;
}

.app-button {
  width: 24px;
  height: 24px;
  border: 0;
  padding: 0;
  vertical-align: middle;
  border-radius: 50%;
  background-color: var(--light);
  box-sizing: border-box;
  text-decoration-color: black;
}

.input-number {
  height: 24px;
}
</style>
